import { render, staticRenderFns } from "./Interregional_Analysis_Materials_Left.vue?vue&type=template&id=55e1106c&scoped=true"
import script from "./Interregional_Analysis_Materials_Left.vue?vue&type=script&lang=js"
export * from "./Interregional_Analysis_Materials_Left.vue?vue&type=script&lang=js"
import style0 from "./Interregional_Analysis_Materials_Left.vue?vue&type=style&index=0&id=55e1106c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1106c",
  null
  
)

export default component.exports